/* For the two inspected Pipeline native cart forms only. No OpenAI key or request. */
(() => {
  'use strict';
  const FORM = 'form[data-kapas-openai-cart]';
  const REF = '__kapas_openai_oppref';
  const CONSENT = '__kapas_openai_consent';
  const STORE = 'kapas_openai_click_v1';
  const TTL = 30 * 24 * 60 * 60 * 1000;
  let privacyReady = false;
  let memory = null;
  let cleared = false;
  let revision = 0;
  let clears = Promise.resolve();

  function allowed() {
    try {
      const p = window.Shopify.customerPrivacy;
      return privacyReady && p.analyticsProcessingAllowed() === true &&
        p.marketingAllowed() === true && p.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function validRef(value) {
    return typeof value === 'string' && value.trim().length > 0 &&
      value !== '{oppref}' && value.length <= 4096;
  }
  function validRecord(record) {
    const now = Date.now();
    return record && validRef(record.value) && Number.isSafeInteger(record.at) &&
      record.at <= now && now - record.at < TTL;
  }
  function forget() {
    memory = null;
    try { window.localStorage.removeItem(STORE); } catch (_) {}
  }
  function referral() {
    if (!allowed()) return '';
    if (validRecord(memory)) return memory.value;
    try {
      const stored = JSON.parse(window.localStorage.getItem(STORE) || 'null');
      if (validRecord(stored)) { memory = stored; return stored.value; }
    } catch (_) {}
    forget();
    return '';
  }
  function captureLanding() {
    if (!allowed()) { forget(); return; }
    try {
      const refs = new URL(window.location.href).searchParams.getAll('oppref');
      if (refs.length === 1 && validRef(refs[0])) {
        // Re-reading this landing page does not renew a previously captured click.
        if (referral() === refs[0]) return;
        memory = { value: refs[0], at: Date.now() };
        try { window.localStorage.setItem(STORE, JSON.stringify(memory)); } catch (_) {}
      }
    } catch (_) {}
  }
  function inputs(form) {
    return [REF, CONSENT].map(key =>
      form.querySelectorAll('input[name="attributes[' + key + ']"]'));
  }
  function blank(form) {
    const groups = inputs(form);
    groups.forEach(group => group.forEach(input => { input.value = ''; }));
    return groups.every(group => group.length === 1 && !group[0].disabled) ?
      groups.map(group => group[0]) : null;
  }
  function resetForms() { document.querySelectorAll(FORM).forEach(blank); }

  function clearOldCartRecord() {
    cleared = false;
    const mine = ++revision;
    resetForms();
    // Only empty values are ever written with Ajax. Positive values use native POST.
    clears = clears.catch(() => {}).then(async () => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 5000);
      try {
        const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
        if (typeof root !== 'string' || !root.startsWith('/') || root.startsWith('//')) return;
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin', signal: controller.signal,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { [REF]: '', [CONSENT]: '' } })
        });
        if (response.ok && mine === revision) cleared = true;
      } catch (_) {
        // Unconfirmed clearing skips measurement; it never interrupts checkout.
      } finally { clearTimeout(timer); }
    });
  }

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form || !form.matches || !form.matches(FORM)) return;
    const fields = blank(form);
    if (!fields || event.defaultPrevented || !event.submitter ||
        event.submitter.name !== 'checkout' || !cleared || !allowed()) return;
    const oppref = referral();
    if (!oppref) return;
    fields[0].value = oppref;
    fields[1].value = JSON.stringify({ schema: 1, a: true, m: true, s: true,
      capturedAt: new Date().toISOString(), source: 'shopify_customer_privacy' });
    // Native form serialization is synchronous. A cancelled submission stays unarmed.
    setTimeout(() => blank(form), 0);
  }, true);

  document.addEventListener('visitorConsentCollected', () => {
    if (allowed()) captureLanding();
    else { forget(); clearOldCartRecord(); }
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) { clearOldCartRecord(); captureLanding(); }
  });
  clearOldCartRecord();
  try {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      privacyReady = !error;
      captureLanding();
    });
  } catch (_) { forget(); }
})();
